import React from 'react';
import { Span } from '../../../../elements';
import { dateHelper } from '../../../../../helpers';

export const Footer: React.FC = () => {
  return (
    <>
      <Span>iPitva</Span>
      <Span>0.0.23</Span>
      <Span>{`(${dateHelper.getCurrentDDMMYYDate()})`}</Span>
    </>
  );
};
